import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbSection, AbContainer, AbDescription } from '../../ui';
import { DEFAULT_SPACING } from '../../../helpers/shared-props';
import { useCdnImg } from '@webplatform/cdn-image';
import { computed } from 'vue-demi';
import { TextAlign } from '../../../types';

interface Props {
  id?: string;
  title?: string;
  subTitle?: string;
  description?: string;
  bgImage?: {
    src?: string;
  };
  textPosition?: TextAlign;
  spacing?: {
    top?: string;
    bottom?: string;
  };
  plain?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSectionBackground',
  props: {
    id: null,
    title: null,
    subTitle: null,
    description: null,
    bgImage: null,
    textPosition: { default: 'center' },
    spacing: { default: () => DEFAULT_SPACING },
    plain: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { id?: string, title?: string, subTitle?: string, description?: string, bgImage?: {
    src?: string;
  }, textPosition: TextAlign, spacing: {
    top?: string;
    bottom?: string;
  }, plain?: boolean };



const { generateUrl } = useCdnImg();
const backgroundImage = computed(() =>
  !props.bgImage || !props.bgImage.src
    ? undefined
    : `url(${generateUrl(props.bgImage.src, {})})`
);

return { __sfc: true,props, generateUrl, backgroundImage, AbTitle, AbSection, AbContainer, AbDescription }
}

})